/* ************************************** */
/* ************* MESSAGE BOX ************ */
/* ******** generates boxes for ********* */
/* warnings / errors / notifies / results */
/* ************************************** */
function MsgBox_initAll() {
    // RESET VALUES ( function could be fired more than once )
    messageBoxTopDistance = 220;
    messageBoxLeftTopDistance = 220;
    messageBoxRightTopDistance = 220;
    $(".messageBox").each(function () {
        var that = this;
        //setTimeout(function() {
        var h = 0;
        animateTimeout += animationDelay;
        if ($(that).hasClass("errorBox") || $(that).hasClass("inputErrorBox"))	// FROM TOP
        {
            animationShowSpeed = 600;
            h = messageBoxTopDistance;
            messageBoxTopDistance += $(that).height() + 10;		// the height is correct at this time
            //-afterwards animation in progress
            MsgBox_slideInFromTop(that, h, animateTimeout);
        } else if ($(that).hasClass("warningBox"))			// FROM LEFT
        {
            animationShowSpeed = 0;
            h = messageBoxLeftTopDistance;
            messageBoxLeftTopDistance += $(that).height() + 10;
            MsgBox_slideInFromLeft(that, h, animateTimeout);
        } else												// FROM RIGHT
        {
            if ($(that).hasClass("infoBox")) {
                animationShowSpeed = 0;
            } else {
                animationShowSpeed = 600;
            }
            h = messageBoxRightTopDistance;
            messageBoxRightTopDistance += $(that).height() + 10;
            MsgBox_slideInFromRight(that, h, animateTimeout);
        }
        //}, animateTimeout);
    });
    $(".messageBox").find("span.close").click(function () {
        $(this).parent().animate({width: 0, height: 0, opacity: 0.0}, animationHideSpeed, function () {
            //callback when animation has finished
            $(this).remove();
        });
    });
    $(".messageBox").hover(function () {
        $(this).addClass("hover");
    }, function () {
        $(this).removeClass("hover");
    });
}
function MsgBox_slideInFromTop(that, topDistance, t) {
    //console.log("top: " + topDistance);
    var storeHeight = $(that).height();
    var storeWidth = $(that).width();
    $(that).css({
        'height': 0,
        'top': topDistance - 100 + "px",
        'left': '50%',
        'marginLeft': '-' + storeWidth / 2 + 'px',
        'opacity': '0.0',
        'display': 'block',
        'zIndex': '50'
    })
        .delay(t)
        .animate({
                'top': topDistance + "px",
                'height': storeHeight + 'px',
                'opacity': '0.9'
            }, animationShowSpeed,
            function () {
                $(that).addClass("finished top");
            })
        .css({'zIndex': '300'});
}
function MsgBox_slideInFromLeft(that, leftTopDistance, t) {
    //console.log("left: " + leftTopDistance);

    var storeWidth = $(that).width();
    var storeHeight = $(that).height();
    //console.log(storeWidth);
    $(that).css({
        'top': leftTopDistance + "px",
        'left': '-' + storeWidth + 'px',
        'opacity': '0.0',
        'display': 'block',
        'zIndex': '50'
    })
        .delay(t)
        .animate({
                'left': '10px',
                'opacity': '0.9'
            }, animationShowSpeed,
            function () {
                $(that).addClass("finished left");
            })
        .css({'zIndex': '300'});
}
function MsgBox_slideInFromRight(that, rightTopDistance, t) {
    //console.log("right: " + rightTopDistance);
    var storeWidth = $(that).width();
    var storeHeight = $(that).height();
    $(that).css({
        'top': rightTopDistance + "px",
        'right': '-' + storeWidth + 'px',
        'opacity': '0.0',
        'display': 'block',
        'zIndex': '50'
    })
        .delay(t)
        .animate({
                'right': '10px',
                'opacity': '0.9'
            }, animationShowSpeed,
            function () {
                $(that).addClass("finished right");
            })
        .css({'zIndex': '300'});
}

